module.exports = __webpack_public_path__ + "static/media/washington-dc-25.705d4e7c.jpg";